import { render, staticRenderFns } from "./NavCompanyLogo.vue?vue&type=template&id=bc89a042&scoped=true&"
import script from "./NavCompanyLogo.vue?vue&type=script&lang=js&"
export * from "./NavCompanyLogo.vue?vue&type=script&lang=js&"
import style0 from "./NavCompanyLogo.vue?vue&type=style&index=0&id=bc89a042&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc89a042",
  null
  
)

export default component.exports